import { FC, HTMLAttributes } from 'react';

type XIconProps = HTMLAttributes<SVGElement> & {
  size?: number;
  fill?: string;
};

const X: FC<XIconProps> = ({ size = 20, fill = '#565960', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="5.71428" fill="white" />
      <path
        d="M14.793 2.5H17.3486L11.7653 8.85384L18.3337 17.5H13.1907L9.16246 12.2561L4.55333 17.5H1.99609L7.96809 10.7038L1.66699 2.5H6.94053L10.5817 7.29309L14.793 2.5ZM13.896 15.9769H15.3121L6.17109 3.94307H4.65143L13.896 15.9769Z"
        fill={fill}
      />
    </svg>
  );
};

export default X;
